import { OrganizationSettings } from "@/features/manage-organizations";
import { requireAdmin } from "@/lib/tanstack-router/requireAdmin";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/organization-settings"
)({
  component: requireAdmin(OrganizationSettingsPage)
});

function OrganizationSettingsPage() {
  return <OrganizationSettings />;
}
